import React from 'react';
import MarkdownPage from '../components/MarkdownPage';

export default function PrivacyPolicy() {
  return <MarkdownPage fetchPath="/assets/privacy-policy.md" pageTitle="Privacy Policy" />;
}
